import { render, staticRenderFns } from "./CopyPriceTemplate.vue?vue&type=template&id=68652c76&scoped=true"
import script from "./CopyPriceTemplate.vue?vue&type=script&lang=js"
export * from "./CopyPriceTemplate.vue?vue&type=script&lang=js"
import style0 from "./CopyPriceTemplate.vue?vue&type=style&index=0&id=68652c76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68652c76",
  null
  
)

export default component.exports